import {
  Button,
  Form,
  PageHeader,
  Row,
  Breadcrumb,
  Col,
  Input,
  message,
  Spin,
  Select,
  DatePicker,
  Divider,
  Typography,
  Table,
  Tag,
} from "antd";
import React, { useState, useEffect } from "react"; 
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { documentService } from "_services/document.service";
import { companyService, stockTypesService, userService, materialTypeService, ApplicationDocumentService  } from "_services";
import { TiepDocumentType, ApplicationStatus ,tiepApplicationStatuses} from "_helpers/enums";
import { Utils } from "_helpers";

const Upload = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedExporter, setSelectedExporter] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [signatureBase64, setSignatureBase64] = useState(null);
  const [signatureFileName, setSignatureFileName] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [exporters, setExporters] = useState([]);
  const [companyAddresses, setCompanyAddresses] = useState([]);
  const [workshopAddresses, setWorkshopAddresses] = useState([]);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);
  const [exporterAddresses, setExporterAddresses] = useState([]);
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [companyDocuments, setCompanyDocuments] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    
    // Set default form values
    form.setFieldsValue({
      applicationStatus: "APPLICATION"
    });
    
    // Fetch companies (manufacturers)
    companyService.getSuggestion("")
      .then((response) => {
        setCompanies(response.content || []);
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });

    // Fetch workshops
    companyService.getSuggestion("")
      .then((response) => {
        setWorkshops(response.content || []);
      })
      .catch((error) => {
        console.error("Error fetching workshops:", error);
      });

    // Fetch exporters
    companyService.getSuggestion("")
      .then((response) => {
        setExporters(response.content || []);
      })
      .catch((error) => {
        console.error("Error fetching exporters:", error);
      });

    // Fetch users
    userService.getAll()
      .then((response) => {
        setUsers(response.content || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        setIsLoading(false);
      });
  }, []);

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        // Get the company ID for the sub-document upload
        const companyId = values.companyData?.id;
        
        if (!companyId) {
          message.error("Please select a company first");
          setIsLoading(false);
          return;
        }

        const payload = {
          linkType: values.linkType,
          applicationDocumentType: "TIEPAPPLICATION",
          applicationStatus: values.applicationStatus,
          validFrom: values.validFrom
            ? values.validFrom.format("YYYY-MM-DD")
            : null,
          validTo: values.validTo ? values.validTo.format("YYYY-MM-DD") : null,
          company: values.companyData,
          companyAddress: values.companyAddressData,
          workshop: values.workshopData,
          addressOfWorkShop: values.workshopAddressData,
          cumExporter: values.cumExporter,
          indirectExporter: values.indirectExporter,
          applicationDate: values.submittedDate
            ? values.submittedDate.format("YYYY-MM-DD")
            : null,
          approvalNumber: values.approvalNumber,
          customRefNumber: values.customRefNumber,
          indirectExporterCompanies: values.indirectExporterCompaniesData,
          exporter: values.exporterData,
          exporterAddress: values.exporterAddressData,
          bom: values.bom,
          importItems: values.importItems,
          requestBankGuarantee: values.requestBankGuarantee,
          requestBankAndExporterGuarantee: values.requestBankAndExporterGuarantee,
          requestExporterGuarantee: values.requestExporterGuarantee,
          authorisedBy: values.authorisedByData,
          designation: values.designation,
          signatureFile: signatureBase64,
          comment: values.comment,
          // Include selected documents for relationship
          subApplicationDocuments: selectedDocuments.map(docId => ({ id: docId })),
          documentName: `Application Document - ${new Date().toLocaleDateString()}`,
          // base64FileString: "data:text/plain;base64,", // Empty placeholder for required field
          // originalFileName: `application_${Date.now()}.txt`, // Generated filename
        };

        // Use the sub-document upload API
        documentService
          .create2(payload)
          .then(() => {
            message.success("Application document created successfully!");
            setIsLoading(false);
            history.push("/documents");
          })
          .catch((error) => {
            setIsLoading(false);
            console.error("Upload error:", error);
            
            // Enhanced error handling
            if (error.response) {
              const status = error.response.status;
              const errorMessage = error.response.data?.message || error.message;
              
              if (status === 400) {
                message.error(`Invalid request: ${errorMessage}`);
              } else if (status === 500) {
                message.error("Server error. Please try again later.");
              } else {
                message.error(`Submission failed: ${errorMessage}`);
              }
            } else if (error.request) {
              message.error("Network error. Please check your connection and try again.");
            } else {
              message.error(`Submission failed: ${error.message || 'Unknown error'}`);
            }
          });
      })
      .catch((error) => {
        console.log("Validation failed:", error);
        message.error("Please fill in all required fields");
      });
  };

  const handleDownloadDocument = (record) => {
    if (!record?.id) return;
    ApplicationDocumentService.downloadSubDocument(record.id)
      .then((response) => {
        const fileNameFromPath = (record.documentLocation || '').split('/').pop();
        const safeName = record.documentName || fileNameFromPath || `document_${record.id}`;
        Utils.downloadFileFromBlob(response, safeName);
      })
      .catch(() => {
      });
  };

  const onCancel = () => {
    history.push("/documents");
  };


  const onSignatureFileChange = (e) => {
    if (e.target.files[0]) {
      setSignatureFileName(e.target.files[0].name);
      let reader = new FileReader();
      reader.onload = function (e) {
        setSignatureBase64(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleCompanyChange = (value, companyId) => {
    setSelectedCompany(value);
    // Reset company address and documents when company changes
    form.setFieldsValue({ 
      companyAddress: undefined,
      companyAddressData: undefined,
      selectedDocuments: undefined
    });
    setSelectedDocuments([]);
    setCompanyDocuments([]);
    
    // Fetch company addresses, products, and documents if companyId is provided
    if (companyId) {
      setIsLoading(true);
      
      // Fetch company addresses
      companyService.getSupplierAddress(companyId)
        .then((response) => {
          setCompanyAddresses(response.content || []);
        })
        .catch((error) => {
          console.error("Error fetching company addresses:", error);
          setCompanyAddresses([]);
        });
      
      // Fetch company documents using sub-document API
      ApplicationDocumentService.getSubDocumentByCompanyId(companyId)
        .then((response) => {
          const documents = response.content || [];
          setCompanyDocuments(Array.isArray(documents) ? documents : [documents]);
          console.log("Company documents loaded:", documents);
        })
        .catch((error) => {
          console.error("Error fetching company documents:", error);
          setCompanyDocuments([]);
          // Don't show error message as this might be expected for new companies
        });
      
      // Fetch finished products
      materialTypeService.getAllFinished()
        .then((response) => {
          setProducts(response.content || []);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
          setProducts([]);
          setIsLoading(false);
        });
    } else {
      setCompanyAddresses([]);
      setProducts([]);
    }
  };

  const getCompanyAddresses = () => {
    return companyAddresses;
  };

  const handleWorkshopChange = (value, workshopId) => {
    setSelectedWorkshop(value);
    // Reset workshop address when workshop changes
    form.setFieldsValue({ 
      workshopAddress: undefined,
      workshopAddressData: undefined 
    });
    
    // Fetch workshop addresses if workshopId is provided
    if (workshopId) {
      setIsLoading(true);
      companyService.getSupplierAddress(workshopId)
        .then((response) => {
          setWorkshopAddresses(response.content || []);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching workshop addresses:", error);
          setWorkshopAddresses([]);
          setIsLoading(false);
        });
    } else {
      setWorkshopAddresses([]);
    }
  };

  const getWorkshopAddresses = () => {
    return workshopAddresses;
  };

  const handleExporterChange = (value, exporterId) => {
    setSelectedExporter(value);
    // Reset exporter address when exporter changes
    form.setFieldsValue({ 
      exporterAddress: undefined,
      exporterAddressData: undefined 
    });
    
    // Fetch exporter addresses if exporterId is provided
    if (exporterId) {
      setIsLoading(true);
      companyService.getSupplierAddress(exporterId)
        .then((response) => {
          setExporterAddresses(response.content || []);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching exporter addresses:", error);
          setExporterAddresses([]);
          setIsLoading(false);
        });
    } else {
      setExporterAddresses([]);
    }
  };

  const getExporterAddresses = () => {
    return exporterAddresses;
  };




  // Get related import items (materials) for a product
  const getRelatedImportItems = (productId) => {
    const product = products.find(p => p.id === productId);
    if (!product || !product.materials) return [];
    
    return product.materials || [];
  };

  // Handle product selection from dropdown
  const handleProductSelection = (selectedValues) => {
    const selectedKeys = selectedValues.map(value => {
      const product = products.find(p => (p.name === value || p.stockTypeName === value));
      return product ? (product.key || product.id) : null;
    }).filter(key => key !== null);
    
    setSelectedProducts(selectedKeys);
    
    // Create BOM data for API submission
    const bomData = selectedValues.map(value => {
      const product = products.find(p => (p.name === value || p.stockTypeName === value));
      return { id: product.id };
    });
    
    // Update form with BOM data for API submission
    form.setFieldsValue({ bom: bomData });
  };

  // Handle row expansion
  const handleExpand = (expanded, record) => {
    const keys = expanded ? [...expandedRowKeys, record.key] : expandedRowKeys.filter(key => key !== record.key);
    setExpandedRowKeys(keys);
  };


  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/documents">Document</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Document Upload</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Button
            key="1"
            htmlType="submit"
            loading={isLoading}
            onClick={handleFormSumbit}
          >
            Save
          </Button>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={false}
            >
              <Row gutter={24}>
                {/* <Col span={6}>
                  <Form.Item name={["applicationDocumentType"]} label="Application Document Type">
                    <Select placeholder="Select Document Type" allowClear>
                     
                        <Option value="TIEPAPPLICATION" key="TIEPAPPLICATION">
                          TIEP APPLICATION
                        </Option>
                      
                    </Select>
                  </Form.Item>
                </Col> */}

                <Col span={6}>
                  <Form.Item name={["applicationStatus"]} label="Application Status">
                    <Select placeholder="Select Application Status" allowClear defaultValue="APPLICATION">
                      {tiepApplicationStatuses.map((status) => (
                        <Option value={status.value} key={status.value}>
                          {status.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>


                <Col span={6}>
                  <Form.Item name={["company"]} label="Company">
                    <Select
                      placeholder="Select Company"
                      onChange={(value) => {
                        const company = companies.find(c => (c.name === value || c.companyName === value));
                        // Transform to the required format
                        const companyData = company ? { id: company.id } : null;
                        form.setFieldsValue({ 
                          companyData: companyData,
                          company: value // Keep display value
                        });
                        handleCompanyChange(value, company ? company.id : null);
                      }}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {companies.map((company) => (
                        <Option value={company.name || company.companyName} key={company.id}>
                          {company.name || company.companyName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name={["companyAddress"]} label="Company Address">
                    <Select
                      placeholder="Select Company Address"
                      onChange={(value) => {
                        const addresses = getCompanyAddresses();
                        const address = addresses.find(a => (a.address === value || a.addressLine1 === value));
                        // Transform to the required format
                        const addressData = address ? { id: address.id } : null;
                        form.setFieldsValue({ 
                          companyAddressData: addressData,
                          companyAddress: value // Keep display value
                        });
                      }}
                      allowClear
                      disabled={!selectedCompany}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {getCompanyAddresses().map((address) => (
                        <Option value={address.address || address.addressLine1} key={address.id}>
                          {address.address || address.addressLine1}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item name="selectedDocuments" label="Company Documents">
                    <Select
                      mode="multiple"
                      placeholder="Select existing documents to relate"
                      onChange={(values) => {
                        setSelectedDocuments(values);
                        console.log("Selected documents:", values);
                      }}
                      allowClear
                      disabled={!selectedCompany || companyDocuments.length === 0}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      notFoundContent={
                        companyDocuments.length === 0 && selectedCompany 
                          ? "No existing documents found for this company" 
                          : "Select a company first"
                      }
                    >
                      {companyDocuments.map((doc) => (
                        <Option value={doc.id} key={doc.id}>
                          {doc.documentName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Selected Documents Table */}
                {selectedDocuments.length > 0 && (
                  <Col span={24} style={{ marginBottom: 10 }}>
                    <Divider orientation="left" style={{ marginTop: 16, marginBottom: 16 }}>
                      <Typography.Title level={5} style={{ margin: 0 }}>
                        Selected Documents ({selectedDocuments.length})
                      </Typography.Title>
                    </Divider>
                    <Table
                      size="small"
                      bordered
                      pagination={false}
                      dataSource={companyDocuments.filter(doc => selectedDocuments.includes(doc.id))}
                      rowKey="id"
                      columns={[
                        {
                          title: 'Document Type',
                          dataIndex: 'applicationDocumentType',
                          key: 'applicationDocumentType',
                          width: '25%',
                          render: (text) => (
                            <span style={{ fontWeight: 'bold' }}>{text}</span>
                          ),
                        },
                        {
                          title: 'Document Name',
                          dataIndex: 'documentName',
                          key: 'documentName',
                          width: '20%',
                          render: (text) => (
                            <span style={{ fontWeight: 'bold' }}>{text}</span>
                          ),
                        },
                        {
                          title: 'Status',
                          dataIndex: 'applicationStatus',
                          key: 'applicationStatus',
                          width: '15%',
                          render: (applicationStatus) => {
                            let color = "";
                            if (applicationStatus === "APPROVAL") {
                              color = "green";
                            } else if (applicationStatus === "CLOSURE") {
                              color = "red";
                            } else if (applicationStatus === "APPLICATION") {
                              color = "blue";
                            } else if (applicationStatus === "EXTENSIONS") {
                              color = "purple";
                            } else if (applicationStatus === "AMENDMENTS") {
                              color = "orange";
                            } else {
                              color = "blue";
                            }
                            return <Tag color={color}>{applicationStatus || 'APPLICATION'}</Tag>;
                          },
                        },
                        {
                          title: 'Action',
                          key: 'action',
                          width: '15%',
                          align: 'center',
                          render: (_, record) => (
                            <Button 
                              type="link" 
                              size="small"                            
                              onClick={() => handleDownloadDocument(record)}
                            >
                              Download
                            </Button>
                          ),
                        },
                      ]}
                      style={{
                        backgroundColor: '#fafafa',
                        border: '1px solid #d9d9d9'
                      }}
                    />
                  </Col>
                )}

                {/* Hidden fields to store the actual data in correct format */}
                <Form.Item name="companyData" style={{ display: 'none', marginTop: 10 }}>
                  <Input />
                  </Form.Item>
                <Form.Item name="companyAddressData" style={{ display: 'none' }}>
                  <Input />
                </Form.Item>

                <Col span={6}>
                  <Form.Item name={["workshop"]} label="Workshop">
                    <Select
                      placeholder="Select Workshop"
                      onChange={(value) => {
                        const workshop = workshops.find(w => (w.name === value || w.companyName === value));
                        // Transform to the required format
                        const workshopData = workshop ? { id: workshop.id } : null;
                        form.setFieldsValue({ 
                          workshopData: workshopData,
                          workshop: value // Keep display value
                        });
                        handleWorkshopChange(value, workshop ? workshop.id : null);
                      }}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {workshops.map((workshop) => (
                        <Option value={workshop.name || workshop.companyName} key={workshop.id}>
                          {workshop.name || workshop.companyName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name={["workshopAddress"]} label="Workshop Address">
                    <Select
                      placeholder="Select Workshop Address"
                      onChange={(value) => {
                        const addresses = getWorkshopAddresses();
                        const address = addresses.find(a => (a.address === value || a.addressLine1 === value));
                        // Transform to the required format
                        const addressData = address ? { id: address.id } : null;
                        form.setFieldsValue({ 
                          workshopAddressData: addressData,
                          workshopAddress: value // Keep display value
                        });
                      }}
                      allowClear
                      disabled={!selectedWorkshop}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {getWorkshopAddresses().map((address) => (
                        <Option value={address.address || address.addressLine1} key={address.id}>
                          {address.address || address.addressLine1}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Hidden fields to store the actual data in correct format */}
                <Form.Item name="workshopData" style={{ display: 'none' }}>
                  <Input />
                </Form.Item>
                <Form.Item name="workshopAddressData" style={{ display: 'none' }}>
                  <Input />
                </Form.Item>

                <Col span={6}>
                  <Form.Item name={["submittedDate"]} label="Submitted Date">
                    <DatePicker
                      placeholder="Submitted Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name={["approvalNumber"]} label="Approval Number">
                    <Input placeholder="Approval Number" />
                  </Form.Item>
                </Col>

                {/* <Col span={6}>
                  <Form.Item name={["tinNo"]} label="TIN No">
                    <Input placeholder="TIN No" />
                  </Form.Item>
                </Col> */}

                <Col span={6}>
                  <Form.Item name={["customRefNumber"]} label="Custom Ref Number">
                    <Input placeholder="Custom Ref Number" />
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name={["cumExporter"]} label="Cum Exporter">
                    <Select
                      placeholder="Select Cum Exporter"
                      allowClear
                    >
                      <Option value={true}>Yes</Option>
                      <Option value={false}>No</Option>
                    </Select>
                  </Form.Item>
                          </Col>

                <Col span={6}>
                  <Form.Item name={["indirectExporter"]} label="Indirect Exporter">
                    <Select
                      placeholder="Select Indirect Exporter"
                      allowClear
                    >
                      <Option value={true}>Yes</Option>
                      <Option value={false}>No</Option>
                    </Select>
                  </Form.Item>
                </Col>

                 <Col span={24}>
                               <Form.Item
                     name="indirectExporterCompanies" 
                     label="Indirect Exporter Companies"
                     rules={[{ required: true, message: "Please select at least one indirect exporter company" }]}
                               >
                                 <Select
                       mode="multiple"
                       placeholder="Select Indirect Exporter Companies"
                       allowClear
                                   showSearch
                                   filterOption={(input, option) =>
                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                       }
                       style={{ width: "100%" }}
                       size="large"
                       onChange={(selectedValues) => {
                         // Transform selected values to the required format
                         const transformedData = selectedValues.map(value => {
                           const exporter = exporters.find(e => e.name === value);
                           return { id: exporter ? exporter.id : value };
                         });
                         // Store the transformed data in the hidden field
                         form.setFieldsValue({ 
                           indirectExporterCompaniesData: transformedData,
                           indirectExporterCompanies: selectedValues // Keep the display values
                         });
                       }}
                                 >
                                   {exporters.map((exporter) => (
                                     <Option value={exporter.name || exporter.companyName} key={exporter.id}>
                                       {exporter.name || exporter.companyName}
                                     </Option>
                                   ))}
                                 </Select>
                               </Form.Item>
                 </Col>

                 {/* Hidden field to store the actual data in correct format */}
                 <Form.Item name="indirectExporterCompaniesData" style={{ display: 'none' }}>
                   <Input />
                 </Form.Item>

                 <Col span={12}>
                   <Form.Item name={["exporter"]} label="Exporter">
                                 <Select
                       placeholder="Select Exporter"
                       onChange={(value) => {
                         const exporter = exporters.find(e => (e.name === value || e.companyName === value));
                         // Transform to the required format
                         const exporterData = exporter ? { id: exporter.id } : null;
                         form.setFieldsValue({ 
                           exporterData: exporterData,
                           exporter: value // Keep display value
                         });
                         handleExporterChange(value, exporter ? exporter.id : null);
                       }}
                       allowClear
                                   showSearch
                                   filterOption={(input, option) =>
                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                       }
                     >
                       {exporters.map((exporter) => (
                         <Option value={exporter.name || exporter.companyName} key={exporter.id}>
                           {exporter.name || exporter.companyName}
                                     </Option>
                                   ))}
                                 </Select>
                   </Form.Item>
                 </Col>

                 <Col span={12}>
                   <Form.Item name={["exporterAddress"]} label="Exporter Address">
                                     <Select
                                   placeholder="Select Exporter Address"
                       onChange={(value) => {
                         const addresses = getExporterAddresses();
                         const address = addresses.find(a => (a.address === value || a.addressLine1 === value));
                         // Transform to the required format
                         const addressData = address ? { id: address.id } : null;
                         form.setFieldsValue({ 
                           exporterAddressData: addressData,
                           exporterAddress: value // Keep display value
                         });
                       }}
                       allowClear
                       disabled={!selectedExporter}
                                       showSearch
                                       filterOption={(input, option) =>
                                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                       }
                                     >
                       {getExporterAddresses().map((address) => (
                                     <Option value={address.address || address.addressLine1} key={address.id}>
                                       {address.address || address.addressLine1}
                                         </Option>
                                       ))}
                                     </Select>
                                   </Form.Item>
                                 </Col>

                 {/* Hidden fields to store the actual data in correct format */}
                 <Form.Item name="exporterData" style={{ display: 'none' }}>
                   <Input />
                                   </Form.Item>
                 <Form.Item name="exporterAddressData" style={{ display: 'none' }}>
                   <Input />
                                   </Form.Item>

                 <Col span={24}>
                   <Divider orientation="left" style={{ marginTop: 24, marginBottom: 16 }}>
                     <Typography.Title level={5} style={{ margin: 0 }}>
                       Export / Manufactured Product Selection
                     </Typography.Title>
                   </Divider>
                 </Col>

                 <Col span={24}>
                   <Form.Item label="Select Products">
                                     <Select
                       mode="multiple"
                       placeholder="Select products to include"
                       onChange={handleProductSelection}
                       style={{ width: '100%' }}
                                       showSearch
                                       filterOption={(input, option) =>
                                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                       }
                       size="large"
                                     >
                                       {products.map((product) => (
                                         <Option value={product.name || product.stockTypeName} key={product.id}>
                                           {product.name || product.stockTypeName}
                                         </Option>
                                       ))}
                                     </Select>
                                   </Form.Item>
                   
                   {selectedProducts.length > 0 && (
                     <div style={{ marginTop: '24px' }}>
                       <Typography.Text strong style={{ marginBottom: '16px', display: 'block', fontSize: '16px', color: '#ffffff' }}>
                         Selected Products ({selectedProducts.length})
                       </Typography.Text>
                       
                       <Table
                         columns={[
                           {
                             title: 'Product Name',
                             dataIndex: 'name',
                             key: 'name',
                             width: '25%',
                             render: (text) => <span style={{ color: '#ffffff', fontWeight: 'bold' }}>{text}</span>,
                           },
                           {
                             title: 'Description',
                             dataIndex: 'description',
                             key: 'description',
                             width: '35%',
                             render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                           },
                           {
                             title: 'Unit',
                             dataIndex: 'defaultUnit',
                             key: 'defaultUnit',
                             width: '10%',
                             render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                           },
                           {
                             title: 'Annual Output',
                             dataIndex: 'defaultAnnualOutput',
                             key: 'defaultAnnualOutput',
                             width: '15%',
                             render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                           },
                           {
                             title: 'Unit Price FOB',
                             dataIndex: 'unitPriceFOB',
                             key: 'unitPriceFOB',
                             width: '15%',
                             render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                           },
                         ]}
                         dataSource={products.filter(p => selectedProducts.includes(p.key || p.id))}
                         pagination={false}
                         expandable={{
                           expandedRowKeys,
                           onExpand: handleExpand,
                           expandedRowRender: (record) => {
                             const relatedItems = getRelatedImportItems(record.id);
                             return (
                               <div style={{ margin: 0, padding: '16px', backgroundColor: 'transparent' }}>
                                 <Typography.Text strong style={{ marginBottom: '16px', display: 'block', color: '#ffffff' }}>
                                   Related Import Items for {record.name}:
                                 </Typography.Text>
                                 <Table
                                   columns={[
                                     {
                                       title: 'Material Name',
                                       dataIndex: ['materialType', 'name'],
                                       key: 'materialName',
                                       width: '25%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                                     },
                                     {
                                       title: 'Code',
                                       dataIndex: ['materialType', 'code'],
                                       key: 'code',
                                       width: '15%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                                     },
                                     {
                                       title: 'Packing Type',
                                       dataIndex: ['materialType', 'packingType', 'name'],
                                       key: 'packingType',
                                       width: '15%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text || 'N/A'}</span>,
                                     },
                                     {
                                       title: 'Quantity Per Unit',
                                       dataIndex: 'quantityPerUnit',
                                       key: 'quantityPerUnit',
                                       width: '15%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                                     },
                                     {
                                       title: 'UOM',
                                       dataIndex: ['uom', 'name'],
                                       key: 'uom',
                                       width: '10%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                                     },
                                     {
                                       title: 'Wastage %',
                                       dataIndex: 'wastagePercentage',
                                       key: 'wastagePercentage',
                                       width: '10%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}%</span>,
                                     },
                                     {
                                       title: 'Conversion Ratio',
                                       dataIndex: 'conversionRatio',
                                       key: 'conversionRatio',
                                       width: '10%',
                                       render: (text) => <span style={{ color: '#ffffff' }}>{text}</span>,
                                     },
                                   ]}
                                   dataSource={relatedItems}
                                   pagination={false}
                                       size="small"
                                   rowKey="id"
                                   className="dark-table"
                                   style={{
                                     backgroundColor: 'transparent',
                                     color: '#ffffff'
                                   }}
                                 />
                               </div>
                             );
                           },
                         }}
                         size="middle"
                         bordered
                         className="dark-table"
                         style={{ 
                           boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                           borderRadius: '6px',
                           backgroundColor: 'transparent',
                           color: '#ffffff'
                         }}
                       />
                     </div>
                  )}
                </Col>

                {/* Hidden field to store BOM data */}
                <Form.Item name="bom" style={{ display: 'none' }}>
                  <Input />
                </Form.Item>

                


                 

                 <Col span={8}>
                   <Form.Item name={["requestBankGuarantee"]} label="Request Bank Guarantee">
                     <Select
                       placeholder="Select Bank Guarantee"
                       allowClear
                     >
                       <Option value={true}>Yes</Option>
                       <Option value={false}>No</Option>
                     </Select>
                                   </Form.Item>
                                 </Col>

                 <Col span={8}>
                   <Form.Item name={["requestBankAndExporterGuarantee"]} label="Request Bank and Exporter Guarantee">
                     <Select
                       placeholder="Select Bank and Exporter Guarantee"
                       allowClear
                     >
                       <Option value={true}>Yes</Option>
                       <Option value={false}>No</Option>
                     </Select>
                                   </Form.Item>
                                 </Col>

                 <Col span={8}>
                   <Form.Item name={["requestExporterGuarantee"]} label="Request Exporter Guarantee">
                     <Select
                       placeholder="Select Exporter Guarantee"
                       allowClear
                     >
                       <Option value={true}>Yes</Option>
                       <Option value={false}>No</Option>
                     </Select>
                   </Form.Item>
                 </Col>

                 <Col span={24}>
                   <Divider orientation="left" style={{ marginTop: 24, marginBottom: 16 }}>
                     <Typography.Title level={5} style={{ margin: 0 }}>
                       Professional Details
                     </Typography.Title>
                   </Divider>
                 </Col>

                 <Col span={8}>
                   <Form.Item name={["authorisedBy"]} label="Authorised By">
                     <Select
                       placeholder="Select Authorised Person"
                       onChange={(value) => {
                        const user = users.find(u => (u.username === value || u.userName === value));
                        // Transform to the required format
                        const authorisedByData = user ? { id: user.id } : null;
                         form.setFieldsValue({ 
                           authorisedByData: authorisedByData,
                           authorisedBy: value // Keep display value
                         });
                       }}
                       allowClear
                       showSearch
                       filterOption={(input, option) =>
                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                       }
                     >
                      {users.map((user) => (
                        <Option value={user.username || user.userName} key={user.id}>
                          {user.username || user.userName}
                         </Option>
                       ))}
                     </Select>
                   </Form.Item>
                 </Col>

                 {/* Hidden field to store the actual data in correct format */}
                 <Form.Item name="authorisedByData" style={{ display: 'none' }}>
                   <Input />
                 </Form.Item>

                 <Col span={8}>
                   <Form.Item name={["designation"]} label="Designation">
                     <Input placeholder="Enter Designation" />
                   </Form.Item>
                 </Col>

                 {/* <Col span={8}>
                   <Form.Item
                     name="signatureFile"
                     label="Signature"
                   >
                     <Input
                       type="file"
                       name="signatureFile"
                       accept=".jpg,.jpeg,.png,.pdf,*"
                       onChange={onSignatureFileChange}
                       allowClear
                     />
                     {signatureFileName && (
                       <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                         Selected: {signatureFileName}
                       </div>
                     )}
                   </Form.Item>
                 </Col> */}
                 
                 {/* 
                 <Col span={6}>
                  <Form.Item name="documentType" label="Document Type">
                    <Select placeholder="Please select" allowClear>
                      {DocumentType.map((age) => (
                        <Select.Option value={age.value} key={age.value}>
                          {age.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                 <Col span={6}>
                  <Form.Item
                    name="file"
                    label="File upload"
                    rules={[
                      {
                        required: true,
                        message: "Valid Excel file is required",
                      },
                    ]}
                    valuePropName="file"
                  >
                    <Input
                      type="file"
                      name="file"
                      onChange={onFileChange}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={5}>
                  <Form.Item name={["validFrom"]} label="Valid From">
                    <DatePicker
                      placeholder="Valid From"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col span={5}>
                  <Form.Item name={["validTo"]} label="Valid To">
                    <DatePicker
                      placeholder="Valid To"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                 <Col span={24}>
                   <Form.Item name={["comment"]} label="Comment">
                     <Input.TextArea placeholder="Comment" rows={4} />
                   </Form.Item>
                 </Col> 
                 */}
              </Row>
             
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
};

export default Upload;
